<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <div class="row">
                <div class="col-sm-12" style="padding-top: 10px">
                    <BootstrapTable style="font-size: 14px;"
                                    ref="table"
                                    v-once
                                    :columns="columns"
                                    :options="{
										classes:'table table-hover',
                                    	undefinedText:'',
                                        showColumns: false,
                                        sidePagination:'server',
                                        pagination:false,
                                        pageNumber:1,
                                        pageSize:10,
                                        pageList:[10,50,100,500],
                                        paginationPreText:'上一页',
                                        paginationNextText:'下一页',
                                        showExtendedPagination:true,
                                        paginationLoop:false
                                    }"
                                    @onPostBody="vueFormatterPostBody"
									@onClickRow="clickRow"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import tableMixin from '@/mixins/table.js';
    export default {
        name:"SysJsqxList",
        mixins: [tableMixin],
        data:function(){
            return {
                query:{

                },
                columns: [
                    {
                        title: '序号',
                        field: 'id',
                        align: 'center',
                        formatter: (value, row, index)=> {
                          return index+1;
                        }
                    },
                    {
                        field: 'js',
                        title: '角色代码'
                    },
                    {
                        field: 'jsmc',
                        title: '角色名称'
                    },
                    {
                        field: 'jsmc',
                        title:"操作",
                        align: 'center',
                        formatter: (value, row) => {
                            return this.vueFormatter({
                                template: '<div class="operation_column">' +
                                    '<a @click="setqx(row)">授权</a>' +
                                    '</div>',
                                data: { row },
                                methods: {
                                    setqx: this.setqx
                                }
                            })
                        }

                    }
                ]
            }
        },
		 mounted(){
			this.query = Object.assign(this.query,{current:1,size:10},this.$route.query);
			this.load();
		 },
		 beforeRouteUpdate(to, from, next){
			 this.query = Object.assign(this.query,{current:1,size:10},to.query);
			this.load();
			next();
		 },
        created:function(){
            this.$store.commit('setBreadcrumb',[{name:'系统管理'},{name:'角色权限管理'}]);
        },
        methods: {
            setqx:function(row){
                this.$router.push({name:'SetJsqxForm',query:{js:row.js, jsmc:row.jsmc}});
            },
			search:function(){
				 //将数据表格的页码以及每一页展示的数据重置为1，10
				let query = Object.assign(this.query,{current:1,size:10},{_t:new Date().getTime()});
				this.$router.push({name:this.$route.name,query:query});
			 },
            load:function(){
                this.$http.post("/htgl/sys/js/cx",this.query).then(res=>{
                    let data = res.data;
                    this.$refs.table.load(data);
                });
            }
        }

    }
</script>
<style scoped>

</style>
